import React, { useCallback, useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import { MultiselectField } from "./MultiselectField";
import type { AttributesValues } from "interfaces/locals/locals.types";

type MultiselectComponentProps = {
  attributes: AttributesValues[];
  obj?: Scrivito.Obj;
};
type SelectOption = Record<string, string>;

export const MultiselectComponent = Scrivito.connect(
  ({ attributes, obj }: MultiselectComponentProps) => {
    const [allOptions, setAllOptions] = useState<
      Record<string, SelectOption[]>
    >({});
    const [optionsSelected, setOptionsSelected] = useState<
      Record<string, SelectOption[]>
    >({});

    useEffect(() => {
      if (attributes && obj) {
        // set all possible options
        const allOptionsSet: Record<string, SelectOption[]> = {};
        attributes.forEach((attr) => {
          allOptionsSet[attr.attribute] = attr.values.sort().map((val) => ({
            value: val,
            label: val,
          }));
        });
        setAllOptions(allOptionsSet);
        // set selected options
        Scrivito.load(() => {
          const selectedOptionsSet: Record<string, SelectOption[]> = {};
          attributes.forEach((attr) => {
            const valuesArr =
              (obj.get(attr.attribute) as string[] | null) || [];

            selectedOptionsSet[attr.attribute] = valuesArr
              .sort()
              .map((val) => ({
                value: val,
                label: val,
              }));
          });
          return selectedOptionsSet;
        }).then((res) => setOptionsSelected(res));
      }
    }, [attributes, obj]);

    const handleChange = useCallback(
      (newSelectValues: SelectOption[], attribute: AttributesValues) => {
        Scrivito.load(() => {}).then(() => {
          obj?.update({
            [attribute.attribute]: newSelectValues.map((item) => item.value),
          });
        });
        setOptionsSelected((values) => ({
          ...values,
          [attribute.attribute]: newSelectValues,
        }));
      },
      [obj],
    );

    return (
      <div className="scrivito_detail_content" style={{ minHeight: "400px" }}>
        {attributes &&
          attributes.map((attr) => (
            <MultiselectField
              key={attr.attribute}
              title={attr.title}
              options={allOptions[attr.attribute]}
              handleChange={handleChange}
              attribute={attr}
              optionsSelected={optionsSelected[attr.attribute]}
            />
          ))}
      </div>
    );
  },
);
